import Help from './Help.vue'

export { Help }
export default Help
